<template>
  <v-container>
    <v-row class="text-center">
      <br /><br />
      <v-col cols="12">
        <v-img
          :src="require('../assets/cpc.jpeg')"
          class="my-3"
          contain
          height="200"
        />
      </v-col>

      <v-col class="mb-4">
        <br /><br />
        <h1 class="display-2 font-weight-bold mb-3" style="color: #111d5e;">
          Welcome to Cape Projects
        </h1>
      </v-col>

      <v-col class="mb-5" cols="12">
        <!-- <h2 class="headline font-weight-bold mb-3">
          What's next?
        </h2> -->

        <!-- <v-row justify="center">
          <a
            v-for="(next, i) in whatsNext"
            :key="i"
            :href="next.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ next.text }}
          </a>
        </v-row> -->
      </v-col>

      <v-col class="mb-5" cols="12">
        <!-- <h2 class="headline font-weight-bold mb-3">
          Important Links
        </h2>

        <v-row justify="center">
          <a
            v-for="(link, i) in importantLinks"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ link.text }}
          </a>
        </v-row> -->
      </v-col>

      <v-col class="mb-5" cols="12">
        <!-- <h2 class="headline font-weight-bold mb-3">
          Ecosystem
        </h2>

        <v-row justify="center">
          <a
            v-for="(eco, i) in ecosystem"
            :key="i"
            :href="eco.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ eco.text }}
          </a>
        </v-row> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HomePage"

  // data: () => ({

  // })
};
</script>
